import { AfterViewInit, Directive, ElementRef, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';
import { fromMutationObserver } from '../utils';

@Directive({
    selector: '[ll-decorated-arrow]'
})
export class LlDecoratedArrowDirective implements AfterViewInit, OnDestroy {
    private readonly BASE_STYLE = `
        border: none;
        padding: 10px;
        outline: none;
        border-bottom: 1px solid #D8D8D8;
        height: 100%;
        color: #616161;
        cursor: pointer;
    `
    constructor(private _el: ElementRef<HTMLElement>) {
        this._el.nativeElement.setAttribute('style', this.BASE_STYLE);
        this._el.nativeElement.style.backgroundColor = this._backgroundColor;
    }

    private _boxShadow = '2px 0px 7px -5px rgba(133, 133, 133, 1)';

    @Input() set side(value: 'left' | 'right') {
        this._boxShadow = value === 'left' ? '2px 0px 7px -5px rgba(133, 133, 133, 1)' : '-2px 0px 7px -5px rgba(133, 133, 133, 1)'
    }

    @Input() set backgroundColor (value: string) {
        this._el.nativeElement.style.backgroundColor = value;
        this._backgroundColor = value;
    }
    private _backgroundColor = '#f2f2f2';
    private _subMgr = new Subscription();

    ngAfterViewInit(): void {
        this._el.nativeElement.style.boxShadow = this._boxShadow;
        this._subMgr.add(fromMutationObserver(this._el.nativeElement, {attributes: true}).pipe(
            map(v => v[0]),
            filter(v => v?.attributeName === 'class'),
            map(v => v.target as HTMLElement),
            tap((v: HTMLElement) => {
                if (v.classList.contains('ll-scroll-button-disabled')) {
                    v.style.color = '#9F9F9F';
                    v.style.boxShadow = ''
                }
                else {
                    v.style.boxShadow = this._boxShadow;
                    v.style.color = '#616161'
                }
            })
        ).subscribe())
    }
    ngOnDestroy(): void {
        this._subMgr.unsubscribe();
    }
}